// extracted by mini-css-extract-plugin
export default {"description":"_1Z5sroOsnIw35iI3AiC0eQ"};